import React from "react";
import CONSTANT from "@environment/index";
import { hideMainLoader, showMainLoader } from "@src/action";
import ProfileServiceInstance from "@containers/Profile/APIs/service";

import { ACTION } from "./constants";
import { getKey, setKey } from "@utils/storage";
import { ERROR_CODE, LOCALSTORAGE, PARAMS_TYPE } from "@constants";
import { isMobile, getDeviceId, showToast, updateUserInfo, safeNavigation } from "@utils/common";
import { toast, ToastContainer } from "react-toastify";
import { LoginSuccessToast } from "@containers/Login/LoginCommon";
import axios from "axios";
import { URL } from "@utils/constants/routeConstants";

export const getProfileDetails = (showLoader) => {
  return (dispatch) => {
    showLoader && dispatch(showMainLoader());
    return ProfileServiceInstance.getProfileDetails()
      .then(function (response) {
        showLoader && dispatch(hideMainLoader());
        const params = { type: PARAMS_TYPE.USER_DETAILS };
        response?.data?.rmn != null && updateUserInfo(response, params);
        dispatch({
          type: ACTION.GET_PROFILE_DETAILS,
          apiResponse: response,
        });
        return response;
      })
      .catch((error) => {
        showLoader && dispatch(hideMainLoader());
        dispatch({
          type: ACTION.GET_PROFILE_DETAILS,
          apiResponse: error,
        });
        console.log("Error while fetching profile details :- " + error);
      });
  };
};

// Step 2: Validate QR Journey
export const validateQRJourney = async (qrCodeId, redirectCode, history) => {
  // debugger;
  try {
    let deviceId = getDeviceId();
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    let anonymousId = getKey(LOCALSTORAGE.ANONYMOUS_ID);
    let header = {
      deviceId: deviceId,
      anonymousId: anonymousId,
      appVersion: "1.0.0",
      subscriberId: userInfo?.sId,
      mobileNumber: userInfo?.rmn,
      bingeSubscriberId: userInfo?.bingeSubscriberId,
      // dthStatus: "DTH With Binge",
      dthStatus: userInfo?.dthStatus ? userInfo?.dthStatus : "DTH With Binge",
      // qrCodeId: qrCodeId ? qrCodeId : "", // optional
      redirectCode: redirectCode,
      platform: "WEB",
      baId: userInfo?.baId,
      "x-authenticated-userid": userInfo?.sId,
      Authorization: "Bearer " + userInfo?.accessToken,
    }

    // if qrCodeId is available then add it other wise do not add it here 
    if (qrCodeId.length > 0) {
      header.qrCodeId = qrCodeId
    }

    const response = await axios.put(
      `${CONSTANT.API_BASE_URL}${CONSTANT.QRJOURNEY}`,
      {},
      {
        headers: header
      }
    );

    console.log("Step 2 Success:", response.data?.data?.successMessage?.length);
    response.data?.data?.successMessage?.length &&
      toast(
        <LoginSuccessToast
          message={
            response.data?.data?.successMessage?.length
              ? response.data?.data?.successMessage
              : "Successfully Logged into TV"
          }
        />,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          className: `login-toast-wrapper`,
          autoClose: 2000,
        }
      );

    if (window.location.href.includes("LoginTv") && response.data?.data?.successMessage?.length) {
      safeNavigation(history, URL.DEFAULT);
    }
    // window.history.pushState({}, '', '/home');
    return response?.data

  } catch (error) {
    console.error("Error in Step 2:", error);
  }
};

export const handleQRLogin = async (qrCodeId) => {
  // Replace this with your actual logic
  console.log("Handling QR login for ID:", qrCodeId);
  let deviceId = getDeviceId();
  // For example, trigger login logic or API call here
  try {
    const response = await axios.get(
      `${CONSTANT.API_BASE_URL}${CONSTANT.QRJOURNEY_DETAILS}`,
      {
        headers: {
          deviceId: deviceId,
          platform: "WEB",
          qrCodeId: qrCodeId, // dynamic
        },
      }
    );

    console.log("Login Details Response:", response.data);
    // return response.data;
    // Call step 2 only if successful
    await validateQRJourney(qrCodeId, response.data?.data.redirectCode); // You can pass data if needed
  } catch (error) {
    console.error("Error fetching login details:", error);
    throw error;
  }
};

export const checkAndHandleQRCode = () => {
  // debugger;
  // const location = useLocation(); // React Router's hook
  // const url = new URL(window.location.href);
  // const pathname = url.pathname;
  // const searchParams = url.searchParams;
  // const pathname = location.pathname;
  // console.log("log--pathname:", pathname);
  // const searchParams = new URLSearchParams(location.search);
  const searchParams = new URLSearchParams(window.location.search);
  const pathname = window.location.pathname;

  if (pathname === "/qr-login" && searchParams.has("qrCodeId")) {
    const qrCodeId = searchParams.get("qrCodeId");
    console.log("Found qrCodeId:", qrCodeId);

    // Call your handler
    handleQRLogin(qrCodeId);
  }
};


<ToastContainer
  autoClose={3000}
  hideProgressBar={true}
  style={{ color: "#000", background: "transparent" }}
  limit={1}
  position={
    isMobile ? toast.POSITION.BOTTOM_CENTER
      : toast.POSITION.TOP_RIGHT
  }
/>;


export const updateProfileDetailsNonDthUser = (payload, callback) => {
  return (dispatch) => {
    dispatch(showMainLoader());
    return ProfileServiceInstance.updateProfileDetailsNonDthUser(payload)
      .then((response) => {
        [ERROR_CODE.ERROR_20109, ERROR_CODE.ERROR_700006].includes(
          response?.code
        )
          ? callback(response)
          : showToast(response.message);
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_PROFILE_DETAILS,
          apiResponse: response,
        });
        return response;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_PROFILE_DETAILS,
          apiResponse: error,
        });
        console.log("Error while updating profile details :- " + error);
      });
  };
};

export const updateEmail = (payload) => {
  return (dispatch) => {
    dispatch(showMainLoader());
    return ProfileServiceInstance.updateEmail(payload)
      .then(function (response) {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_EMAIL,
          apiResponse: response,
        });
        return response;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_EMAIL,
          apiResponse: error,
        });
        console.log("Error while updating email :- " + error);
      });
  };
};

export const updateProfileImage = (payload) => {
  return (dispatch) => {
    dispatch(showMainLoader());
    return ProfileServiceInstance.updateProfileImage(payload)
      .then(function (response) {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_PROFILE_IMAGE,
          apiResponse: response,
        });
        return response;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.UPDATE_PROFILE_IMAGE,
          apiResponse: error,
        });
        console.log("Error while updating user profile image :- " + error);
      });
  };
};

export const switchToAtvAccount = () => {
  return (dispatch) => {
    dispatch(showMainLoader());
    return ProfileServiceInstance.switchToAtvAccount()
      .then(function (response) {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.SWITCH_TO_ATV_ACC,
          apiResponse: response,
        });
        return response;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.SWITCH_TO_ATV_ACC,
          apiResponse: error,
        });
        console.log("Error while switching to ATV Profile :- " + error);
      });
  };
};

export const handleAtvUpgrade = () => {
  return (dispatch) => {
    dispatch(showMainLoader());
    return ProfileServiceInstance.handleAtvUpgrade()
      .then(function (response) {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.HANDLE_ATV_UPGRADE,
          apiResponse: response,
        });
        setKey(LOCALSTORAGE.ATV_UPGRADE, false);
        return response;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        dispatch({
          type: ACTION.HANDLE_ATV_UPGRADE,
          apiResponse: error,
        });
        console.log(
          "Error while handling ATV upgrade popup API call  :- " + error
        );
      });
  };
};
export const setProfileImage = (imageSrc) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_PROFILE_IMAGE,
      response: imageSrc,
    });
  };
};
